var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Local que ocorrerá o evento")]),_vm._v(" "),_c('gmap-autocomplete',{ref:"inputAutocomplete",staticClass:"form-control form-control-alternative",staticStyle:{"width":"100%"},attrs:{"placeholder":"","value":_vm.place,"required":""},on:{"place_changed":_vm.setPlace}}),_vm._v(" "),_c('GmapMap',{ref:"mapRef",staticStyle:{"width":"100%","height":"600px","margin-top":"10px"},attrs:{"center":_vm.marker,"zoom":_vm.defaultZoom,"options":{
                zoomControl: true,
                mapTypeControl: false,
                scaleControl: false,
                streetViewControl: false,
                rotateControl: false,
                fullscreenControl: true,
                disableDefaultUi: false,
                gestureHandling: 'cooperative'
              }}},[_c('Gmap-Marker',{attrs:{"position":_vm.gps || _vm.marker,"draggable":true},on:{"dragend":_vm.setMarkerByClick}})],1),_vm._v(" "),_c('small',[_vm._v("Você pode clicar no mapa para marcar o local desejado.")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ae74b01","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Trg/EventsSpecifications/EventLocalMap.vue
// module id = ycPt
// module chunks = 10